module.exports = __webpack_public_path__ + "img/47400.93ac6935.jpg";